import styled from 'styled-components';

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
